<clr-vertical-nav-group
    class="sel-secondary-nav-{{ state.label }}"
    [clrVerticalNavGroupExpanded]="expanded$ | async"
    (clrVerticalNavGroupExpandedChange)="handleExpandedChange($event)"
>
    <clr-icon
        *ngIf="state.icon"
        class="sel-clr-icon"
        shape="{{ state.icon }}"
        clrVerticalNavIcon
    ></clr-icon>
    {{ state.label }}
    <clr-vertical-nav-group-children
        class="sel-{{ state.label }}-list-subhdr"
    >
        <ng-container *ngFor="let childState of state.children; trackBy: trackByState">
            <button
                class="sel-link-text vertical-nav-group__nav-button"
                uiSrefActive="active"
                [uiSref]="childState.name"
                *permissionCheck="childState.name | stateNameToPermission"
                clrVerticalNavLink
            >
                {{ childState.label }}
            </button>
        </ng-container>
    </clr-vertical-nav-group-children>
</clr-vertical-nav-group>
